import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import CloseIcon from '@components/icons/ModalClose.svg';
import { useModalContext } from '@providers/ModalProvider';
import { Content } from './styles/Content';
import { Wrapper } from './styles/Wrapper';
import { TProps } from './types/TProps';

export const ModalWrapper = ({ width, overflow, children, className = 'modal-wrapper', onCancel }: TProps) => {
  const { closeModal } = useModalContext();

  const close = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    closeModal();
  };

  return (
    <Wrapper width={width} overflow={overflow} className={className}>
      <IconButtonClean type="button" title="Close" className="close-icon" onClick={close}>
        <CloseIcon />
      </IconButtonClean>
      <Content overflow={overflow}>{children}</Content>
    </Wrapper>
  );
};
